module.exports = __webpack_public_path__ + "img/logo-odmc-225x80.348f2434.png";